import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CheckoutButton } from '../CheckoutButton';
const before = ['Information scattered across multiple sources', 'Too much text to find one concept', 'No clear study sequence', 'Similar classifications are easy to confuse', 'Slow review sessions', 'Reading without knowing what you actually remember', 'Constantly switching between resources'];
const after = ['A clear study path', 'Concepts organized visually', 'Know what to review and when', 'Easy-to-scan comparison guides', 'Visual maps connecting related topics', 'Checklists to track your progress', '15-minute review sessions', 'A system you can return to before every exam'];
export function BeforeAfter() {
  return <section className="bg-navy-900 px-4 py-14 sm:py-20" data-id="element-83" data-mp="2ldlf7hytv1wz">
      <div className="mx-auto w-full max-w-5xl" data-id="element-84" data-mp="1evybpcmww486">
        <div className="text-center" data-id="element-85" data-mp="19w3mremp5opr">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-aqua-200" data-id="element-86" data-mp="19v27sz2k8i2r">
            🧭 From a student lost in notes…
          </p>
          <h2 className="mt-3 font-display text-[26px] font-bold leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-87" data-mp="1c4gv4sjy498v">
            To a student who knows exactly what to review
          </h2>
        </div>

        <div className="mt-9 grid gap-4 md:grid-cols-2 md:gap-5" data-id="element-88" data-mp="133ipk5tuzto6">
          <div className="rounded-2xl bg-white/5 p-5 ring-1 ring-white/10 sm:p-6" data-id="element-89" data-mp="131xxqnyxiou0">
            <h3 className="flex items-center gap-2 text-[13px] font-extrabold uppercase tracking-wide text-red-300" data-id="element-90" data-mp="odbi0l5e3v29">
              <span className="flex h-6 w-6 items-center justify-center rounded-md bg-red-500/20" data-id="element-91" data-mp="t7o1uwas38ej">
                <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-92" data-mp="fc3k446scw8p" />
              </span>
              Before Prostho 360™
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-93" data-mp="5fh01hmaa97q">
              {before.map(item => <li key={item} className="flex gap-2.5" data-id="element-94" data-mp="af3lufg6gxs5">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-95" data-mp="aek7t9tnetje" />
                  <span className="text-[14.5px] leading-snug text-white/70" data-id="element-96" data-mp="2c5u3e8armcf6">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl bg-aqua-500/12 p-5 ring-1 ring-aqua-400/40 sm:p-6" data-id="element-97" data-mp="23bfpa91z17xn">
            <h3 className="flex items-center gap-2 text-[13px] font-extrabold uppercase tracking-wide text-aqua-300" data-id="element-98" data-mp="1yd4hs4z5f9il">
              <span className="flex h-6 w-6 items-center justify-center rounded-md bg-aqua-400/25" data-id="element-99" data-mp="2v3eulm105n2y">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-100" data-mp="2r1a2irq7cyif" />
              </span>
              With Prostho 360™
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-101" data-mp="2m0m2xhnwr9cl">
              {after.map(item => <li key={item} className="flex gap-2.5" data-id="element-102" data-mp="2h2u8ogzsjb58">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-aqua-400" aria-hidden="true" data-id="element-103" data-mp="1antas5r7giw0" />
                  <span className="text-[14.5px] font-medium leading-snug text-white" data-id="element-104" data-mp="15nns3f2wy6q2">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-9" data-id="element-105" data-mp="10jcwvhxadbuu">
          <CheckoutButton label="I want Prostho 360™" sub="Instant digital access · 7-Day Guarantee" data-id="element-106" data-mp="10ik0navye4qy" />
        </div>
      </div>
    </section>;
}